__turbopack_context__.v({
  "backdropHidden": "_5K39Ua_backdropHidden",
  "contentWrapper": "_5K39Ua_contentWrapper",
  "contentWrapperWithScroll": "_5K39Ua_contentWrapperWithScroll",
  "dropdownMenuItem": "_5K39Ua_dropdownMenuItem" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "mobileBackdrop": "_5K39Ua_mobileBackdrop",
  "scrollableContent": "_5K39Ua_scrollableContent",
});
